import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FormContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: 1,
  padding: theme.spacing(3),
}));
